import { useEffect } from 'react'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { startAlertStreams } from '@/api/notification/stream/alertStreamRuntime.ts'

/**
 * 로그인한 모든 비공용 화면에서 긴급·낙상 알림 스트림을 유지한다.
 * 생체 스트림은 생체 화면의 훅이 직접 구독한다(좌표가 담겨 있어 화면이 열린 클라이언트에만 보낸다).
 */
const AlertLiveStreamManager = () => {
    useEffect(() => {
        if (DISABLE_ALERTS_LIVE_FETCHING) return undefined
        return startAlertStreams()
    }, [])

    return null
}

export default AlertLiveStreamManager
